import React from "react";

const AlertsList = ({ alerts }) => {
  const getColor = (type) => {
    switch (type) {
      case "Critical":
        return "bg-red-500";
      case "Warning":
        return "bg-yellow-400";
      default:
        return "bg-blue-400";
    }
  };

  return (
    <div className="bg-gray-800 p-4 rounded-xl shadow-md">
      <h3 className="text-lg font-bold mb-4">Alerts</h3>
      <div className="space-y-3 max-h-80 overflow-y-auto">
        {alerts.length === 0 ? (
          <p className="text-gray-400">No alerts yet</p>
        ) : (
          alerts.map((alert) => (
            <div
              key={alert.id}
              className="flex items-center justify-between p-3 rounded-md bg-gray-700 hover:bg-gray-600 transition"
            >
              <div className="flex items-center gap-3">
                <span className={`w-3 h-3 rounded-full ${getColor(alert.type)}`}></span>
                <div>
                  <p className="font-semibold">{alert.type}</p>
                  <p className="text-sm text-gray-300">{alert.message}</p>
                </div>
              </div>
              <span className="text-xs text-gray-400">{alert.time}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AlertsList;
